export const MaxTagSize = 50;
export const HideToastAfterMilliseconds = 6000;
export const ParseIntDefaultRadix = 10;
export const DocumentViewerCloseEventName = 'document_viewer_close';
export const DownloadRequestToken = 'rfe-download-request-token';
export const DownloadRequestEchoToken = 'rfe-download-echo-token';
export const BytesPerMB = 1048576; // 1024 * 1024
